
/* Local Imports */
import { Download, Features, SectionWrapper } from "./Components";
import { useEffect,useState } from "react";
import styles from "./Styles/Global";
import {  useLocation } from "react-router-dom";
import {  urlFor } from "../../client";
import Lottie from "lottie-react";
import LoadingAnimation from "../../assets/MainLoading.json";
const ShowCase = () => {
  const date = new Date();
  const year = date.getFullYear();
  const location = useLocation();
  const { showcase } = location.state || {};// Access the project object from the location state
  const [loading, setLoading] = useState(true);
  const [showcaseData, setShowcaseData] = useState({});
  
  const {
    titleOne,
    descriptionOne,
    mockUpImageOne,
    showDeployBtn,
    titleTwo,
    descriptionTwo,
    mockUpImageTwo,
    techStack,
    technologyDescription,
    deploymentTitle,
    deploymentDescription,
    deploymentImage,
    thirdTitle,
    thirdDescription,
    thirdImage,
    sourceCodeLink,
    sourceCodeImage,
    showSourceCodeBtn,
  }
    = showcaseData;
useEffect(() => {
	const fetchShowcaseData = async () => {
		try {
			await new Promise((resolve) => setTimeout(resolve, 500));
			const data = await showcase[0]; 
			setShowcaseData(data);
      setLoading(false); 
      
    } catch (err) {
      console.error(err);
    }
	};

  fetchShowcaseData();
}, [showcase]);
 
  return loading ? (
		<div className="flex justify-center items-center h-screen">
			<Lottie
				className="w-1/4"
				animationData={LoadingAnimation}
				loop
			/>
		</div>
  ) : (
		<>
			<SectionWrapper
				title={titleOne}
				desc={descriptionOne}
				showBtn={showDeployBtn}
				mockupImage={urlFor(mockUpImageOne).url()}
				banner="banner"
			></SectionWrapper>
			<SectionWrapper
				title={titleTwo}
				desc={descriptionTwo}
				mockupImage={urlFor(mockUpImageTwo).url()}
				reverse
			></SectionWrapper>
			<Features
				techStack={techStack}
				technologyDescription={technologyDescription}
			/>
			<SectionWrapper
				title={deploymentTitle}
				desc={deploymentDescription}
				mockupImage={urlFor(deploymentImage).url()}
				reverse
			></SectionWrapper>
			<SectionWrapper
				title={thirdTitle}
				desc={thirdDescription}
				mockupImage={urlFor(thirdImage).url()}
				banner="banner02"
			></SectionWrapper>
			<Download
				showSource={showSourceCodeBtn}
				sourceCodeLink={sourceCodeLink}
				sourceCodeImage={sourceCodeImage}
			/>
			<div className="px-4 py-2 justify-center items-center bg-primary flex-col text-center banner04">
				<p className={`${styles.pText} ${styles.whiteText}`}>
					<span className="m-2 sm:m-4 lg:m-10 text-sm">
						© {year} Taimoor Khan. All Rights Reserved.
					</span>
				</p>
			</div>
		</>
  );
}

export default ShowCase;
